<template>
  <div class="Assets">
    <header class="Assets__Header">
      <div class="row">
        <div class="col-5 col-sm-4">
          <h2>{{ $t("assets.your_assets") }}</h2>
        </div>

        <div
          class="col-7 col-sm-8 d-flex justify-content-end align-items-center"
        >
          <!-- <ExchangeMenu class="mr-3 mr-sm-5" /> -->
          <SortMenu class="mr-3 mr-sm-5" />
          <AddAssetButton :text="$t('assets.add_asset')" />
        </div>
      </div>
    </header>

    <main>
      <AssetTable />
    </main>
  </div>
</template>

<script>
// import ExchangeMenu from "./ExchangeMenu.vue";
import SortMenu from "./SortMenu.vue";
import AddAssetButton from "./AddAssetButton.vue";
import AssetTable from "./AssetTable.vue";

export default {
  name: "Assets",
  components: {
    // ExchangeMenu,
    SortMenu,
    AddAssetButton,
    AssetTable,
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.Assets {
  margin-top: 120px;

  @include breakpoint-manual(max-width, $break-small - 1px) {
    margin-top: 80px;
  }
}

.Assets__Header {
  border-bottom: 3px solid $color-primary;
  padding: 0 0 8px;
  margin: 0 0 30px;

  h2 {
    margin: 0;

    @include breakpoint-manual(max-width, $break-extra-small - 1px) {
      margin-top: 5px;
    }
  }
}
</style>
